import { useEffect } from "react";
import api from "@/lib/api";

// Loads analytics scripts from admin-configured site settings.
// SAFETY: Only <script> tags are extracted; arbitrary HTML is discarded.
// Only admins can set the analytics_code via the protected /api/site-settings
// endpoint, so this is not a public XSS surface.
function extractScriptTags(code) {
  const out = [];
  // Match <script ...>...</script> blocks. `s` flag lets `.` match newlines.
  const re = /<script([^>]*)>([\s\S]*?)<\/script\s*>/gi;
  let m;
  while ((m = re.exec(code)) !== null) {
    const attrs = {};
    const attrRe = /([\w:-]+)\s*=\s*"([^"]*)"|([\w:-]+)\s*=\s*'([^']*)'/g;
    let am;
    while ((am = attrRe.exec(m[1])) !== null) {
      const name = am[1] || am[3];
      const val = am[2] || am[4];
      if (name) attrs[name.toLowerCase()] = val;
    }
    out.push({ attrs, text: m[2] || "" });
  }
  return out;
}

export default function AnalyticsInjector() {
  useEffect(() => {
    let mounted = true;
    let appended = [];
    api.get("/site-info")
      .then((r) => {
        if (!mounted) return;
        const code = r.data?.analytics_code || "";
        if (!code.trim()) return;
        for (const { attrs, text } of extractScriptTags(code)) {
          const s = document.createElement("script");
          if (attrs.src) s.src = attrs.src;
          if (attrs.async !== undefined) s.async = true;
          if (attrs.defer !== undefined) s.defer = true;
          if (attrs.type) s.type = attrs.type;
          if (attrs["data-domain"]) s.setAttribute("data-domain", attrs["data-domain"]);
          if (attrs["data-website-id"]) s.setAttribute("data-website-id", attrs["data-website-id"]);
          if (text) s.text = text;
          document.head.appendChild(s);
          appended.push(s);
        }
      })
      .catch((err) => console.error("Analytics load failed:", err));
    return () => {
      mounted = false;
      appended.forEach((n) => { try { n.parentNode?.removeChild(n); } catch (e) { /* ignore */ } });
    };
  }, []);
  return null;
}
